import { render, staticRenderFns } from "./StudyProgramDetails.vue?vue&type=template&id=19f8cc32&scoped=true&"
import script from "./StudyProgramDetails.vue?vue&type=script&lang=ts&"
export * from "./StudyProgramDetails.vue?vue&type=script&lang=ts&"
import style0 from "./StudyProgramDetails.vue?vue&type=style&index=0&id=19f8cc32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f8cc32",
  null
  
)

export default component.exports